import { Backdrop, CircularProgress } from '@mui/material'
import clsx from 'clsx'
import classes from './styles.module.scss'

interface Props {
  open: boolean
}

export const Loader = ({ open }: Props) => {
  return (
    <Backdrop open={open} className={classes.loader}>
      <CircularProgress
        color="inherit"
        className={classes.progress}
      />
    </Backdrop>
  )
}

interface OverlayProps {
  open: boolean
  className?: string
}

Loader.Overlay = ({ open, className }: OverlayProps) => {
  if (!open) return null

  return (
    <div className={clsx(classes.overlay, className)}>
      <CircularProgress
        color="inherit"
        className={classes.progress}
      />
    </div>
  )
}
